import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';

import Select, { SelectItem } from '../ui/Select';
import { FmsUser } from '../fms.core/FmsUser';
import ApplicationContext from '../ApplicationContext';
import { UserParams } from '../fms.core/constants';

function UsersDropDown({
  value,
  onChange = () => {},
  disabled = false,
  items = [],
  maxLength = undefined,
  name=undefined,
  selectId,
  useAll = false,
  hasSubscriberId = false,
  userEditable  = false,
  clearInactiveText = false,
}: {
  value: string|null|undefined,
  disabled?: boolean,
  //onChange?: (x:FmsUser|null) => void,
  onChange?: (userId: string) => void,
  items?: Array<FmsUser>,
  maxLength?: number|undefined,
  name?: string|undefined,
  selectId?: string,
  useAll?: boolean,
  hasSubscriberId?: boolean,
  userEditable?: boolean,
  clearInactiveText?: boolean,
}) {
  const appContext = useContext(ApplicationContext);

  const [data, setData] = useState<Array<FmsUser>>([]);
  const [inactiveData, setInactiveData] = useState<FmsUser[]>([]);
  let inactiveText = '';

  async function fetchData(api:any) {
    // var base = new UserParams();
    // base.comboType = FmsComboType.User;
    // base.hasSubscriberId = hasSubscriberId;
    // base.userEditable = userEditable;
    // const data = await api.loadCodeData([base]);
    // if (data && data.length > 0) {
    //   if(useAll) data[0].items.unshift("ALL");
    //   setData(data[0].items);
    // }

    try {
      const data = await api.loadCodeData([new UserParams({
        inclInactive: true, 
        hasSubscriberId, 
        userEditable,
      })]);
      if (!data || data.length === 0) return;

      const list = data[0].items as FmsUser[];
      setData(list.filter(x => !x.inactiveDate));
      setInactiveData(list.filter(x => x.inactiveDate));
    } catch (e) {
      console.error("UsersDropDown load error", e);
    }
  }

  function handleChange(e:React.ChangeEvent<HTMLInputElement>) {
    // if (!e.target.value) {
    //   onChange(null);
    //   return;
    // }
    
    // onChange(data.find(x => x.userId === e.target.value) ?? null);
    onChange(e.target.value);
  }

  useEffect(() => {
      if (items && items.length > 0) {
        setData(items);
      } else {
      fetchData(appContext.api);
      }
    
      return () => {
        setData([]);
      }
  },
   // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const displayData:Array<SelectItem> = [
    {value: '', label: '', activeLabel: '' },
    ...data.map(x => ({ value: x.userId, label: x.userId }))
  ];

  if (useAll) {
    displayData.unshift({ value: 'ALL', label: 'ALL'});
  }

  //const isInclude = displayData.some(x => x.value === value);

  if (value) {
    const selected = inactiveData.find(x => x.userId === value);
    if (selected) {
      inactiveText = selected.userId ?? '';
    }
  }

  return (
    <Select
      selectId={selectId}
      name={name}
      maxLength={maxLength}
      //value={(value === null || value === undefined || !isInclude) ? '' : value}
      value={(value === null || value === undefined) ? '' : value}
      onChange={handleChange}
      disabled={disabled}
      items={displayData}
      inactiveText={inactiveText}
      clearInactiveText={clearInactiveText}
    />
  );
}

UsersDropDown.defaultProps = {
  onChange: () => {},
  disabled: false,
  useAll: false,
  clearInactiveText: false,
};

UsersDropDown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
  items: PropTypes.array,
  selectId: PropTypes.string,
  useAll: PropTypes.bool.isRequired,
  clearInactiveText: PropTypes.bool.isRequired,
};

export default React.memo(UsersDropDown);
